import TBD from "../../TBD";

function Dashboard() {
  return (
    <>
      <TBD />
    </>
  );
}

export default Dashboard;
